const routes = [
  {
    pageComponent: '/index',
    path: '/',
    patterns: null,
  },
  {
    pageComponent: '/premiersports',
    path: '/premiersports',
    patterns: null,
  },
  {
    pageComponent: '/accountSummary',
    path: '/account',
    patterns: null,
    noCache: true,
  },
  {
    pageComponent: '/episode',
    path: '/episode',
    patterns: [
      '/:episodeIdHash',
      '/:episodeIdHash/:programme',
      '/:episodeIdHash/:programme/:episodeName',
    ],
    noCache: true,
  },
  {
    pageComponent: '/episodeRedirect',
    path: '/episodes',
    patterns: [
      '/:episodeId',
    ],
    noCache: true,
  },
  {
    pageComponent: '/episode',
    path: '/video',
    patterns: [
      '/:episodeIdHash',
      '/:episodeIdHash/:programme',
      '/:episodeIdHash/:programme/:episodeName',
    ],
    noCache: true,
  },
  {
    pageComponent: '/live',
    path: '/live',
    patterns: [
      '/',
      '/:channel',
    ],
    noCache: true,
  },
  {
    pageComponent: '/categories',
    path: '/categories',
    patterns: [
      '/',
      '/:category',
    ],
    noCache: true,
  },
  {
    pageComponent: '/summary',
    path: '/summary',
    patterns: [
      '/:programme',
    ],
  },
  {
    pageComponent: '/myList',
    path: '/my-list',
    patterns: null,
    noCache: true,
  },
  {
    pageComponent: '/tvguide',
    path: '/tvguide',
    patterns: [
      '/',
      '/:channel',
      '/:channel/:date',
    ],
  },
  {
    pageComponent: '/pageError',
    path: '/error',
    patterns: null,
  },
  {
    pageComponent: '/premSportsLanding',
    path: '/player-plus-premier-sports',
    patterns: null,
  },
  {
    pageComponent: '/playerPlusTermsLanding',
    path: '/player-plus-terms',
    patterns: null,
  },
  {
    pageComponent: '/playerPlusLandingRefresh',
    path: '/player-plus',
    patterns: null,
  },
  {
    pageComponent: '/headlessLanding',
    path: '/content',
    patterns: [
      '/:slug',
    ],
  },
  {
    pageComponent: '/partnerLanding',
    path: '/partners',
    patterns: [
      '/:slug',
    ],
  },
  {
    pageComponent: '/infoPage',
    path: '/info',
    patterns: [
      '/:guid',
    ],
  },
  {
    pageComponent: '/standAlonePages',
    path: '/mobile',
    patterns: [
      '/:guid',
    ],
  },
  {
    pageComponent: '/settings',
    path: '/settings',
    patterns: null,
    noCache: true,
  },
  {
    pageComponent: '/sitemap',
    path: '/sitemap.xml',
    patterns: null,
  },
  {
    pageComponent: '/search',
    path: '/search',
    patterns: null,
  },
]

module.exports = {
  assetPrefix: '/player-web',
  assetTypes: 'png|jpe?g|gif|woff|woff2|ico|svg',
  routes,
  facebookAppId: '167069041547',
  publisherId: '1055753', // Google ads publisher ID
  googleTagManagerId: 'GTM-N8943NG6',
}
